import Markdown from './Markdown';
import './App.css';

function App() {
  return (
    <Markdown></Markdown>
  );
}

export default App;
